import { formDataRequest } from './axios_ml'

export const uploadInvoice = (file) => {
  const formData = new FormData()
  formData.append('file', file)

  return formDataRequest({
    path: '/api/ml/invoice',
    method: 'post',
    data: formData
  })
}